import React from "react";
import"./Shimmer.css";

// const shimmer_card_unit = 20;

const ShimmerCard = () => {
  return (
    <div className="shimmer-cards">
      <div className="shimmer-img stroke animate"></div>
      <div className="shimmer-title stroke animate"></div>
      <div className="shimmer-tags stroke animate "></div>
      <div className="shimmer-details stroke animate "></div>
    </div>
  );
};

const Shimmer = ({number}) => {
    return (
        <div className="shimmer-container">
            {new Array(number).fill(0).map((element, index) => {
                return <ShimmerCard key={index} />
            })}
        </div>
    )
}

export default Shimmer;